import React from "react";
import { TextField } from "@mui/material";

const TextInput = ({label='',value='',onChange='', name="", disabled,width }) =>{
    return(
        <TextField
        fullWidth
        label={label}
        value={value}
        onChange={onChange}
        name={name}
        disabled={disabled}
        size="small"
        style={{width:width}}
        // InputLabelProps={{shrink: true}}
        />
    )
}


export default TextInput;